import React, { useState } from 'react';
import Slider from 'react-slick';
import { STYLES, OPTIONAL_LENSES, TIPS } from './constants';
import './BodyJunni.scss';

export const BodyJunni = ({ baseImgUrl }) => {
  const [selectedColors, setSelectedColors] = useState({});

  const handleColorClick = (productCode, color) => {
    setSelectedColors(prev => ({
      ...prev,
      [productCode]: color,
    }));
  };

  const getSelectedColor = (productCode, product) => {
    return selectedColors[productCode] || product?.colors?.[0];
  };

  const settings = {
    infinite: false,
    arrows: true,
    dots: false,
    slidesToScroll: 2,
    slidesToShow: 1.8,
    responsive: [
      {
        breakpoint: 768,
        settings: {
          infinite: true,
          arrows: false,
          dots: true,
          centerMode: true,
          variableWidth: false,
          slidesToScroll: 1,
          slidesToShow: 1,
        },
      },
    ],
  };

  return (
    <div className="body-junni">
      <section className="body-junni__styles">
        <div className="body-junni__styles-inner">
          {STYLES?.map(style => (
            <div key={style?.id} className="body-junni__style" id={style?.id}>
              <div className="body-junni__style-top">
                <picture
                  className={`body-junni__style-top-img body-junni__style-top-img--${style?.id}`}
                >
                  <source
                    media="(min-width: 768px)"
                    srcSet={`${baseImgUrl}/model-${style?.id}_pc.webp`}
                  />
                  <img
                    alt="Junni Kids Glasses"
                    loading="lazy"
                    src={`${baseImgUrl}/model-${style?.id}_sp.webp`}
                  />
                </picture>
                <div
                  className={`body-junni__style-top-content body-junni__style-top-content--${style?.id}`}
                >
                  {style?.stickers?.map((sticker, index) => (
                    <img
                      key={sticker}
                      alt="Junni Kids Glasses"
                      className={`body-junni__style-top-content-img body-junni__style-top-content-img--${
                        index + 1
                      }`}
                      loading="lazy"
                      src={`${baseImgUrl}/${sticker}`}
                    />
                  ))}
                  <h3 className="body-junni__style-top-content-title">{style?.title}</h3>
                  <p className="body-junni__style-top-content-description">{style?.description}</p>
                </div>
              </div>
              {style?.products?.length > 0 && (
                <ul
                  className={`body-junni__style-products ${
                    style?.products?.some(product => product?.features?.length > 0)
                      ? 'has-features'
                      : ''
                  }`}
                >
                  {style?.products?.map(product => {
                    const selectedColor = getSelectedColor(product?.code, product);
                    return (
                      <li key={product?.code} className="body-junni__style-products-item">
                        <div
                          className={`body-junni__style-product ${product?.new ? 'is-new' : ''}`}
                        >
                          <img
                            alt={product?.code}
                            className="body-junni__style-product-img"
                            loading="lazy"
                            src={`${baseImgUrl}/products/${product?.code}/${selectedColor?.img}`}
                          />
                          <div className="body-junni__style-product-inner">
                            <div className="body-junni__style-product-content">
                              <div className="body-junni__style-product-info">
                                <p className="body-junni__style-product-code">
                                  {product?.code} {selectedColor?.id}
                                </p>
                                <p className="body-junni__style-product-price">
                                  S${product?.price}
                                </p>
                              </div>
                              <div className="body-junni__style-product-colors">
                                {product?.colors?.map((color, index) => (
                                  <button
                                    key={color?.id}
                                    className={`body-junni__style-product-color ${
                                      selectedColor?.id === color?.id ? 'is-active' : ''
                                    }`}
                                    style={{
                                      backgroundImage: `url("${baseImgUrl}/${color?.colorImg}")`,
                                      backgroundColor: color?.colorHex,
                                    }}
                                    onClick={() => handleColorClick(product?.code, color)}
                                  >
                                    {color?.id}
                                  </button>
                                ))}
                              </div>
                            </div>
                            {/* <a className="base-junni__btn" href={`/sg/en/${selectedColor?.url}`}>
                              <span>More Details</span>
                            </a> */}
                          </div>
                        </div>
                        {product?.features?.length > 0 && (
                          <Slider className="body-junni__style-product-features" {...settings}>
                            {product?.features?.map((feature, index) => (
                              <div key={feature} className="body-junni__style-product-feature">
                                <img
                                  alt={feature}
                                  className="body-junni__style-product-feature-img"
                                  loading="lazy"
                                  src={`${baseImgUrl}/products/${product?.code}/feature-${
                                    index + 1
                                  }.webp`}
                                />
                                <p className="body-junni__style-product-feature-description">
                                  {feature}
                                </p>
                              </div>
                            ))}
                          </Slider>
                        )}
                      </li>
                    );
                  })}
                </ul>
              )}
            </div>
          ))}
        </div>
      </section>
      <section className="body-junni__optional-lenses">
        <div className="body-junni__optional-lenses-inner">
          <h2 className="body-junni__optional-lenses-title">OPTIONAL LENSES</h2>
          {OPTIONAL_LENSES?.length > 0 && (
            <ul className="body-junni__optional-lenses-list">
              {OPTIONAL_LENSES?.map(lens => (
                <li key={lens?.title} className="body-junni__optional-lenses-item">
                  <img
                    alt={lens?.title}
                    className="body-junni__optional-lenses-item-img"
                    loading="lazy"
                    src={`${baseImgUrl}/${lens?.img}`}
                  />
                  <div className="body-junni__optional-lenses-item-content">
                    <h3 className="body-junni__optional-lenses-item-title">{lens?.title}</h3>
                    <p className="body-junni__optional-lenses-item-description">
                      {lens?.description}
                    </p>
                    <a className="body-junni__optional-lenses-item-link" href={lens?.url}>
                      More Details
                    </a>
                  </div>
                </li>
              ))}
            </ul>
          )}
        </div>
      </section>
      <section className="body-junni__tips">
        <div className="body-junni__tips-inner">
          <h2 className="body-junni__tips-title">OWNDAYS TIPS</h2>
          {TIPS?.length > 0 && (
            <ul className="body-junni__tips-list">
              {TIPS?.map(tip => (
                <li key={tip?.description} className="body-junni__tips-item">
                  <img
                    alt={tip?.description}
                    className="body-junni__tips-item-img"
                    loading="lazy"
                    src={`${baseImgUrl}/${tip?.img}`}
                  />
                  <div className="body-junni__tips-item-content">
                    <p className="body-junni__tips-item-description">{tip?.description}</p>
                    <a className="body-junni__tips-item-link" href={tip?.url}>
                      More Details
                    </a>
                  </div>
                </li>
              ))}
            </ul>
          )}
        </div>
      </section>
    </div>
  );
};
